import Youtube from './_components/youtube.vue';
import Vimeo from './_components/vimeo.vue';
import Facebook from './_components/facebook.vue';
import defaultVideo from './_components/default.vue';
import common from './common.js';

export default {
    createVideo(options) {
        if (this.isYoutube(options.src)) {
            return Youtube;
        }

        if (this.isVimeo(options.src)) {
            return Vimeo;
        }

        if (this.isFacebook(options.src)) {
            return Facebook;
        }

        return defaultVideo;
    },
    isYoutube(src) {
        return common.getYoutubeId(src);
    },
    isVimeo(src) {
        return common.getVimeoId(src);
    },
    isFacebook(src) {
        let decodeUrl = decodeURIComponent(src);
        return common.getFacebookId(decodeUrl);
    }
};
